import '../assets/custom.scss'

import React from 'react'
import { Page } from 'src/components'
import { ReportMain } from 'src/components/page/report-main/report-main'
import { ReportFeatures } from 'src/config/features'
import { FeaturesProvider } from 'src/contexts/features.context'
import { PageProvider } from 'src/contexts/page.context'
import { SecurityProvider } from 'src/contexts/security.context'
import { StockReportProvider } from 'src/contexts/stock-report.context'
import { NoopAuthService } from 'src/integrations/auth/no-op.service'
import { StockopediaRestClient } from 'src/integrations/http-client/stockopedia.client'
import { ApiClientProvider } from 'src/integrations/stock-reports-client/context'
import { StockReportsClient } from 'src/integrations/stock-reports-client/stock-reports.app.client'
import { StockReportData } from 'src/shared/security.dto'

interface Props {
  pageContext: {
    pageData: {
      selectedNavIndex: number
      reportName: string
      siteUrl: string
    }
    report: StockReportData
    env: {
      apiUrl: string
    }
    features: ReportFeatures
  }
}

export default function StockReport({
  pageContext: { pageData, report, env, features },
}: Props) {
  const client = new StockReportsClient(
    new StockopediaRestClient(new NoopAuthService(), env.apiUrl),
  )

  return (
    <PageProvider data={pageData}>
      <FeaturesProvider data={{ features }}>
        <SecurityProvider data={{ security: report.security }}>
          <StockReportProvider data={{ report }}>
            <ApiClientProvider client={client}>
              <Page>
                <ReportMain />
              </Page>
            </ApiClientProvider>
          </StockReportProvider>
        </SecurityProvider>
      </FeaturesProvider>
    </PageProvider>
  )
}
